// extracted by mini-css-extract-plugin
export default {"button":"IFButtonSkeleton_button__XcWkD"};